// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  cursor: auto;
  pointer-events: auto;
  visibility: hidden;
}
.swiper-wrapper > .swiper-slide{
  width: 88px;
  height: 88px;
}

.swiper-slide button{
  width: 50px;
  height: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/client/bindings/Swiper.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  cursor: auto;\n  pointer-events: auto;\n  visibility: hidden;\n}\n.swiper-wrapper > .swiper-slide{\n  width: 88px;\n  height: 88px;\n}\n\n.swiper-slide button{\n  width: 50px;\n  height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
